
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/2022-en-xifres",
      function () {
        return require("private-next-pages/2022-en-xifres.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/2022-en-xifres"])
      });
    }
  